import {
  aboutUs,
  accessibility,
  backmarketWarranty,
  blackFriday,
  boMerchant,
  buyBack,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  giftCards,
  giftFinder,
  help,
  hireExternal,
  infosConsumer,
  insurances,
  legal,
  modelsComparison,
  studentGoodDeals,
  termsBuyback,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const frConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        {
          translationKey: 'press',
          href: '/fr-fr/about-us#scroll=false&target=heading-2-kit-média',
        },
        {
          translationKey: 'impact',
          href: "/fr-fr/about-us#scroll=false&target=heading-2-rapport-d'impact",
        },
        accessibility,
        {
          translationKey: 'trustpilot',
          href: 'https://fr.trustpilot.com/review/www.backmarket.fr',
        },
        hireExternal,
      ],
      socials: [
        { name: 'instagram', href: 'https://www.instagram.com/backmarket' },
        {
          name: 'youtube',
          href: 'https://www.youtube.com/channel/UCXJ_vW2t0W5hY9hS8ePnpzw',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/BackMarketCom',
        },
        { name: 'x', href: 'https://x.com/back_market' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'contactUs',
          href: 'https://help.backmarket.com/hc/fr-fr/articles/360026654654-Comment-puis-je-contacter-le-service-client%C3%A8le-de-Back-Market',
        },
        help,
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/fr-fr/articles/360026646054-Dans-quel-pays-puis-je-me-faire-livrer-et-combien-cela-me-co%C3%BBte',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/fr-fr/categories/360002106194-Retours-Remboursements',
        },
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [
        backmarketWarranty,
        insurances,
        buyBack,
        studentGoodDeals,
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.fr/fr-fr/seller/home',
        },
        boMerchant,
        { translationKey: 'pro', href: 'https://pro.backmarket.fr' },
        {
          translationKey: 'paymentMethods',
          href: 'https://help.backmarket.com/hc/fr-fr/articles/360026643854-Quels-sont-les-moyens-de-paiement-accept%C3%A9s-sur-Back-Market',
        },
      ],
    },
    {
      titleKey: 'categoryGuides',
      links: [
        giftCards,
        buyingGuides,
        modelsComparison,
        giftFinder,
        blackFriday,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        termsBuyback,
        cookiePolicy,
        dataProtection,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/fr-fr/requests/new?ticket_form_id=12226993197084',
        },
      ],
    },
    {
      logos: ['bcorp', 'best-e-commerce-website'],
    },
  ],
}
